<template>
  <div>
    <Banner/>
    <News-English/>
    <div class="nrk" @click="EnglishNews">
        <img src="img/lxwmE.jpg" class="xlwm">
    </div>
  </div>
</template>

<script>
import Banner from '@/components/pc/Banner';
import NewsEnglish from '@/components/pc/NewsEnglish';
export default {
    components:{
      Banner,
      NewsEnglish,
    },
    methods: {
        EnglishNews(){
            this.$router.push({name:'EnglishNews'})
        },
    },
}
</script>

<style scoped>
    .xlwm{
        width: 100%;
        margin: 30px 0;
        display: block;
        cursor: pointer;
    }
    @media (max-width: 768px){
      .xlwm{
        display: none;
      }
    }
</style>